import { BCMSDefaultModel, BCMSRecord, BCMSStateManagerCRUD, useBCMSContext, useModel } from "@bcm-dev/bcms-vite";
import { Transaction, TransactionDispute } from "model";
import TransactionDetailsPage, { getDefaultData } from "components/pages/TransactionDetailsPage";

export default function CaptureDisputeTransactionDetailsUpdated(props) {
    const controller = useBCMSContext();
    BCMSRecord.globalControllerFor([ Transaction, TransactionDispute ], controller);
    const { branding } = useModel();
    const options = branding.options ?? {};
    let transactionID = "98"; // A credit card transaction id.
    if(options.include_credit_chw23 === "false") {
        transactionID = "5"; // A debit card transaction id.
    }
    const defaultData = getDefaultData(transactionID);
    const defaultTransactionDispute = BCMSDefaultModel.transactionDispute();
    // Init here to prevent modifying a property by reference.
    const transactionCopy = Transaction.init({ ...defaultData.transaction.record });
    transactionCopy.transactionDispute = defaultTransactionDispute;
    const data = BCMSStateManagerCRUD.init(defaultData)
    .update(["transaction"], transactionCopy)
    .submit();

    return (
        <TransactionDetailsPage data={ data } />
    );
}